<template>
  <el-select v-model="departmentId" placeholder="请选择所属部门" @change="onSelectDepartmentChanged" filterable>
    <el-option
      v-for="item in departmentList"
      :key="item.dept_id"
      :label="item.dept_name"
      :value="item.dept_id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "selectDepartment",


  props:[
    'index',
    'departId'
  ],
  data(){
    return{
      departmentId:'',
      departmentList:[],
    }
  },

  watch:{
    departId:{
      immediate:true,
      deep:true,
      handler(val){
        this.departmentId=val;
      }
    }
  },

  mounted() {
    this.http.api('departmentList')
        .then(res=>{
          if(res.status){
            this.departmentList=res.data;
          }
        })
        .catch(error=>{
        })
  },

  methods:{
    onSelectDepartmentChanged(e){
      this.$emit('onSelectDepartmentChanged',e,this.index)
    }
  }
}
</script>

<style scoped>

</style>
